var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "pa-0", attrs: { "grid-list-xs": "", fluid: "" } },
        [
          _c(
            "v-form",
            { ref: "suifile_form" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "", lg4: "", xl4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "dense_input",
                        attrs: {
                          "append-outer-icon": "search",
                          clearable: "",
                          outline: "",
                          label: "# OF",
                          rules: [_vm.required, _vm.numOf],
                          loading: _vm.loading
                        },
                        on: {
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getOfDetails(_vm.form.parameters.num_of)
                          },
                          "click:append-outer": function($event) {
                            return _vm.getOfDetails(_vm.form.parameters.num_of)
                          },
                          "click:clear": function($event) {
                            return _vm.onOfClear()
                          },
                          change: function($event) {
                            return _vm.onFormChange()
                          }
                        },
                        model: {
                          value: _vm.form.parameters.num_of,
                          callback: function($$v) {
                            _vm.$set(_vm.form.parameters, "num_of", _vm._n($$v))
                          },
                          expression: "form.parameters.num_of"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm2: "", md2: "", lg2: "", xl2: "" } },
                    [
                      _c("v-select", {
                        staticClass: "dense_input",
                        attrs: {
                          outline: "",
                          dense: "",
                          disabled: _vm.of.fvodserv.length === 0,
                          loading: _vm.loading,
                          items: _vm.of.fvodserv,
                          rules: [_vm.required, _vm.numFab],
                          label: "# FAB"
                        },
                        on: {
                          change: function($event) {
                            _vm.onFormChange()
                            _vm.getAssetDetails($event)
                          }
                        },
                        model: {
                          value: _vm.form.parameters.num_fab,
                          callback: function($$v) {
                            _vm.$set(_vm.form.parameters, "num_fab", $$v)
                          },
                          expression: "form.parameters.num_fab"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md6: "", lg6: "", xl6: "" } },
                    [
                      _c("v-select", {
                        staticClass: "dense_input",
                        attrs: {
                          outline: "",
                          dense: "",
                          items: _vm.hosts,
                          rules: [],
                          label: "Machine"
                        },
                        model: {
                          value: _vm.host_path,
                          callback: function($$v) {
                            _vm.host_path = $$v
                          },
                          expression: "host_path"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-textarea", {
                        staticClass: "dense_input",
                        attrs: {
                          outline: "",
                          "auto-grow": "",
                          loading: _vm.loading,
                          disabled: _vm.of.fvodserv.length === 0,
                          rules: [],
                          label: "Commentaire"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onFormChange()
                          }
                        },
                        model: {
                          value: _vm.form.parameters.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.form.parameters, "comment", $$v)
                          },
                          expression: "form.parameters.comment"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "dense_input file-input",
                        attrs: {
                          outline: "",
                          readonly: "",
                          label: "Chemin du fichier",
                          loading: _vm.loading,
                          "append-outer-icon": "folder",
                          rules: [_vm.required],
                          prefix: _vm.getFileBasename(
                            _vm.form.parameters.source_path
                          )
                        },
                        on: {
                          change: function($event) {
                            return _vm.onFormChange()
                          },
                          "click:append-outer": function($event) {
                            _vm.show_explorer = true
                          }
                        },
                        model: {
                          value: _vm.form.parameters.source_path,
                          callback: function($$v) {
                            _vm.$set(_vm.form.parameters, "source_path", $$v)
                          },
                          expression: "form.parameters.source_path"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.of.details
            ? _c(
                "v-layout",
                { staticClass: "pt-2", attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _c("table", [
                      _c("tbody", [
                        _c("tr", [
                          _c("th", { staticClass: "px-2 py-1" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tTitre Principal\n\t\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "px-2 py-1" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.of.titre_princ) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { staticClass: "px-2 py-1" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tTitre secondaire\n\t\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "px-2 py-1" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.of.titre_sec) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { staticClass: "px-2 py-1" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tObservations\n\t\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "px-2 py-1" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.of.observations) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { staticClass: "px-2 py-1" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tRéférence SUIFA\n\t\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "px-2 py-1" },
                            [
                              _vm.of.file_ref === "00_00_0000"
                                ? _c(
                                    "span",
                                    { staticClass: "subheading error--text" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.of.file_ref) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "subheading primary--text" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.of.file_ref) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                              _vm._v(" "),
                              _vm.loading_file_ref
                                ? _c("v-progress-linear", {
                                    staticClass: "ma-0",
                                    attrs: { height: 2, indeterminate: true }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-alert",
            {
              staticClass: "py-0 my-2",
              attrs: { type: "error", value: _vm.error !== false }
            },
            [_vm._v("\n\t\t\t" + _vm._s(_vm.error) + "\n\t\t")]
          ),
          _vm._v(" "),
          _vm.debug
            ? _c("tree-view", {
                staticClass: "ma-2 background darken-1 pa-2",
                attrs: {
                  data: _vm.form,
                  options: { maxDepth: 0, rootObjectKey: "form" }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.debug
            ? _c("tree-view", {
                staticClass: "ma-2 background darken-1 pa-2",
                attrs: {
                  data: _vm.of,
                  options: { maxDepth: 0, rootObjectKey: "of" }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.show_explorer
        ? _c(
            "Explorer",
            {
              attrs: {
                shortcuts: _vm.hosts,
                assetType: _vm.asset_type,
                multiselect: false,
                default_folder: _vm.host_path
              },
              on: {
                close: function($event) {
                  _vm.show_explorer = false
                },
                selectedAssets: function($event) {
                  return _vm.onSelectedAsset($event.path)
                }
              }
            },
            [
              _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("Asset Select for Maestro ingester")
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a21c0af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a21c0af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/jobs/launcher/job_launcher_form_suifile_fvodserv.vue
// module id = null
// module chunks = 